const quiz = {
  sampleBotContent: {
    schemaVersion: 1,
    templateType: "quiz",
    items: [
      { id: "q1", question: "¿Qué día viene antes del martes?", answers: ["lunes"], image: null },
      { id: "q2", question: "¿Qué día viene antes del viernes? ", answers: ["jueves"], image: null },
      { id: "q3", question: "¿Qué día viene después del miércoles? ", answers: ["jueves"], image: null },
      { id: "q4", question: "¿Qué día viene antes del domingo?", answers: ["lunes"], image: null },
      { id: "q5", question: "¿Qué día viene antes del jueves? ", answers: ["viernes"], image: null },
      { id: "q6", question: "¿Qué día viene antes del viernes?", answers: ["sábado"], image: null },
      { id: "q7", question: "¿Qué día viene antes del sábado? ", answers: ["Domingo"], image: null },
      { id: "q8", question: "¿Qué día viene antes del domingo?", answers: ["lunes"], image: null },
      { id: "q9", question: "Sábado y domingo son el...", answers: ["fin de semana"], image: null },
      { id: "q10", question: "Hay _____ días en la semana", answers: ["7", "siete"], image: null },
    ],
  },
  botId: "nualang.quiz.0.0.1",
  botName: "quiz",
  description: "quiz_desc",
  difficulty: "ALL",
  learnLang: "spanish",
  name: "Alonso",
  botAvatar:
    "https://images.nualang.com/eyJidWNrZXQiOiJudWFsYW5nLWltYWdlcy1wcm9kIiwia2V5IjoiYXZhdGFycy8wLW51YWxhLTAwMS5wbmcifQ==",
  picture: `${process.env.REACT_APP_API}/image-creator/848/480/691f89/ffffff/fa-question-circle?fontSize=200`,
  creatorInstructions: "",
  studentInstructions: `# Bienvenido al cuestionario
Alojado por Penélope.

¿Conoces los días de la semana?

Saluda a Alonso para comenzar.`,
  voice: "Alonso",
  versionQuestion: "¿Cuántas preguntas le gustaría en esta plantilla?",
};

export default quiz;
